import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import {filter, takeUntil} from 'rxjs/operators';

import {FuseConfigService} from '@fuse/services/config.service';
import {FuseNavigationService} from '@fuse/components/navigation/navigation.service';
import {FuseSidebarService} from '@fuse/components/sidebar/sidebar.service';
import {AuthService} from '@app/services/auth/auth.service';
import {fuseAnimations} from '../../../../../../../@fuse/animations';
import {ActivatedRoute, Router} from '@angular/router';
import {ChangeLang} from '@store/actions/auth.actions';
import {Store} from '@ngrx/store';
import {AppState} from '@store/app.states';
import {TranslateService} from '@ngx-translate/core';
import {find} from 'lodash-es';
import {getCurrentUserLang} from '@store/selectors/auth.selector';
import {canUserChangeLang} from '@app/components/projects/surveys/results/dashboard/store/dashboard-results.selectors';
import {fuseConfig} from '@app/components-fuse/fuse-config';

@Component({
    selector: 'navbar-horizontal-style-1',
    templateUrl: './style-1.component.html',
    styleUrls: ['./style-1.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: false
})
export class NavbarHorizontalStyle1Component implements OnInit, OnDestroy {
  fuseConfig: any;
  navigation: any;

  languages: any;
  selectedLanguage: any;
  curLang: string;

  // Private
  private _unsubscribeAll: Subject<any>;
  canUserChangeLang = false;

  /**
   * Constructor
   *
   // tslint:disable-next-line:no-redundant-jsdoc
   * @param {FuseConfigService} _fuseConfigService
   * @param {FuseNavigationService} _fuseNavigationService
   * @param {FuseSidebarService} _fuseSidebarService
   */
  constructor(
    private store: Store<AppState>,
    public authService: AuthService,
    public router: Router,
    private _fuseConfigService: FuseConfigService,
    private _fuseNavigationService: FuseNavigationService,
    private _fuseSidebarService: FuseSidebarService,
    private _translateService: TranslateService
  ) {

    this.languages = [
      {
        id: 'en',
        title: 'English',
        flag: 'us',
      },
      {
        id: 'fr',
        title: 'Français',
        flag: 'fr',
      },
      // {
      //   id: 'nl',
      //   title: 'Nederlands',
      //   flag: 'nl',
      // },
    ];

    // Set the private defaults
    this._unsubscribeAll = new Subject();
    // Initialize fuseConfig with default config to ensure navbar renders correctly
    this.fuseConfig = fuseConfig;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Get current navigation
    this._fuseNavigationService.onNavigationChanged
      .pipe(
        filter(value => value !== null),
        takeUntil(this._unsubscribeAll)
      )
      .subscribe(() => {
        this.navigation = this._fuseNavigationService.getCurrentNavigation();
      });

    // Subscribe to the config changes
    this._fuseConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config) => {
        this.fuseConfig = config;
      });

    this.store.select(getCurrentUserLang).subscribe((data) => {
      this.curLang = data;
    });

    this.store.select(canUserChangeLang).subscribe((canUserChangeLang) => {
      this.canUserChangeLang = canUserChangeLang;
    });

    this.curLang = this._translateService.currentLang;
    this.selectedLanguage = find(this.languages, {
      id: this._translateService.currentLang,
    });


  }

  goInbeWebsite(): void {
    window.open('https://www.inbe.ca', '_blank');
  }

  goHome(): void {
    this.router.navigate(['/']);
  }


  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  /**
   * Set the language
   *
   */
  setLanguage(lang): void {
    this.store.dispatch(new ChangeLang({newLang: lang}));
  }

}
